module.exports = __webpack_public_path__ + "img/sign_apply_model.aff0958a.png";